namespace C2S {
    export interface ServiceError {
        Code?: string;
        Arguments?: string;
        Message?: string;
    }
}